import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Motion from '@/app/components/Motion';

interface FeaturesEyebrowProps {
  readonly label: MessageKey;
}

const FeaturesEyebrow = ({ label }: FeaturesEyebrowProps) => {
  const t = useTranslations();
  return (
    <Motion
      className="xl:mt-24"
      initial={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      whileInView={{ opacity: 1 }}
    >
      <Typography
        className="mb-2 text-base tracking-wider uppercase lg:mb-4"
        Element="h2"
        weight="bold"
        color="inherit"
      >
        {t(label)}
      </Typography>
    </Motion>
  );
};

export default FeaturesEyebrow;
